import { useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGrid, itIT, GridToolbar, useGridApiRef } from '@mui/x-data-grid';		//https://mui.com/x/react-data-grid/ [MIT version]
import { Box, Alert, Button } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

import Api from '../../Services/Api';
import {PAGE_SIZE, pageSizeOptions} from '../../Config/constants.js';
import ActionButton from '../ActionButton.js';

function InstallationList(props) {
	const { hook, lastUpdate, customer } = props;
	const apiRef = useGridApiRef();	//https://mui.com/x/api/data-grid/

	const columns = [
		{
			field: 'unique_code',
			headerName: 'Codice impianto',
			flex: 1,
		},
		{
			field: 'brand',
			headerName: 'Marca',
			flex: 1,
		},
		{
			field: 'model',
			headerName: 'Modello',
			flex: 1,
		},
		{
			field: 'serial',
			headerName: 'Matricola',
			flex: 1,
		},
		{
			field: 'closed_at',
			headerName: 'Chiuso',
			type: 'boolean',
			valueGetter: (params) => {
				return params.row.closed_at ? true : false
			},
		},
		{
			field: 'verified',
			headerName: 'Verificato',
			type: 'boolean',
			valueGetter: (params) => {
				return params.row.verified ? true : false
			},
		},
		{
			field: 'id',
			headerName: 'Azioni',
			flex: 1,
			renderCell: (params) => {
				function onEdit(e) {
					e.stopPropagation(); // don't select this row after clicking
					hook("edit", params.value);
				};
				function onDelete(e) {
					e.stopPropagation(); // don't select this row after clicking
					if (window.confirm("Confermare l'eliminazione DEFINITIVA dell'Impianto?")) {
						if (window.confirm("Eliminare l'Impianto?")) {
							hook("delete", params.value);
						}
					}
				};
                function onMove(e) {
					e.stopPropagation(); // don't select this row after clicking
					hook("move", params.value + "|" + customer);
				};
				return <>
					<ActionButton title={"Modifica Impianto"} onClick={onEdit}>
						<EditIcon />
					</ActionButton>
					<ActionButton title={"Elimina Impianto"} onClick={onDelete}>
						<DeleteIcon />
					</ActionButton>
					<ActionButton title={"Sposta Impianto"} onClick={onMove}>
						<SwapHorizIcon />
					</ActionButton>
				</>
			}
		},
	]

	function newElement() {
		hook("create");
	}

	const [rows, setRows] = useState([]);
	const [displayAlert, setDisplayAlert] = useState(0);

	useEffect(() => {
		try {
			Api.get({endpoint: `installation/list/${customer}`, contentType : 'application/json'})
			.then(response => {
				setRows(response.data.installations);
			})
			.catch(error => {
				console.log(JSON.stringify(error));
				setDisplayAlert(-1);
			});
		} catch (error) {
			console.log(JSON.stringify(error));
			setDisplayAlert(-1);
		}
	}, [lastUpdate]);	// eslint-disable-line react-hooks/exhaustive-deps

	const theme = createTheme({
			palette: {
				primary: { main: '#11cb5f' },
			},
		},
		itIT,
	);
	return (
		<>
			<Box sx={{ width: '100%', minWidth: '800px' }}>
				<ThemeProvider theme={theme}>
					<DataGrid
						//onRowDoubleClick={hook}
						sx={{ minHeight: '300px' }}
						rows={rows}
						columns={columns}
						initialState={{
							pagination: {
								paginationModel: {
									pageSize: PAGE_SIZE,
								},
							},
						}}
						apiRef={apiRef}
						slots={{
							toolbar: GridToolbar,
						}}
						slotProps={{
							columnsPanel: {
								disableHideAllButton: true,
							}
						}}
						pageSizeOptions={pageSizeOptions}
					/>
					<div className="mt-2">
						<Button
							variant="contained"
							onClick={newElement}
						>
							Nuovo Impianto
						</Button>
					</div>
				</ThemeProvider>
				{displayAlert === -1 && (
					<Alert severity="error">Si è verificato un errore imprevisto. Riprovare più tardi</Alert>
				)}
			</Box>
		</>
	);
}

export default InstallationList;